import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const messageImporterSelectors = importerSelectors(
  'message.importer',
)

export default messageImporterSelectors
